export default "__VITE_ASSET__B9kJB5W1__"